import Ajax from '../ajax';

export default {
  // exchanger
  list: (data) => Ajax('get', 'exchanger', data),
  get: (exchangerId) => Ajax('get', `exchanger/${exchangerId}`),
  add: (data) => Ajax('post', 'exchanger', data),
  edit: (exchangerId, data) => Ajax('put', `exchanger/${exchangerId}`, data),
  delete: (exchangerId) => Ajax('delete', `exchanger/${exchangerId}`),
  modifyStatus: (exchangerId, isEnable) => Ajax('put', `exchanger/${exchangerId}/enable?enabled=${isEnable}`),
  // exchangerCurrency
  currencyList: (exchangerId, data) => Ajax('get', `exchanger/${exchangerId}/currency`, data),
  currency: (exchangerId, currencyId) => Ajax('get', `exchanger/${exchangerId}/currency/${currencyId}`),
  currencyOption: (exchangerId, optionType) => Ajax('get', `exchanger/${exchangerId}/currency/option?optionType=${optionType}`),
  addCurrency: (data) => Ajax('post', `exchanger/${data.exchangerId}/currency`, data),
  editCurrency: (data) => Ajax('put', `exchanger/${data.exchangerId}/currency/${data.currencyId}`, data),
  deleteCurrency: (exchangerId, currencyId) => Ajax('delete', `exchanger/${exchangerId}/currency/${currencyId}`),
  currencyRecentRate: (exchangerId, currencyId) => Ajax('get', `exchanger/${exchangerId}/currency/${currencyId}/closedrate`),
  setDailyRate: (data) => Ajax('post', `exchanger/${data.exchangerId}/currency/${data.currencyId}/closedrate`, data),
  downloadFiltedDailyTranscrion: (data) => Ajax('get', `exchanger/${data.exchangerId}/currency/${data.currencyId}/download?date=${data.date}`),
  uploadDailyTranscrionResult: (data) => Ajax('post', `exchanger/${data.exchangerId}/currency/${data.currencyId}/upload`, data),
};
